

async function fetchCartItems() {
    let cartNotification = document.querySelector('#shopping-cart');
    let data = await fetch('/cart.json')
    let jsonData = await data.json();
    if (jsonData.item_count > 0) {  
        cartNotification.innerHTML += `
        <style>
            .notification-tooltip {
                width: 20px;
                height: 20px;
                position: absolute;
                top: 0;
                transform: translateX(10px);
                z-index: 100;
                background-color: red;
                color: #fff;
                padding: 10px;
                border-radius: 50%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                font-size: 12px;
                font-weight: bold;

            }
        </style>
            <div class="notification-tooltip">
                ${jsonData.item_count}
            </div>
        `;
    }
}


window.addEventListener('load', () => {
    fetchCartItems();
});
